
export default {
  name: 'ContactComponent',
  inheritAttrs: false,
  computed: {
    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    iconContact() {
      const icon = {
        name: 'adviser',
        size: '34px',
      };

      if (this.$session.get('brand') === 'volkswagen') {
        icon.size = '30px';
      }

      return icon;
    },
    iconWhatsapp() {
      const icon = {
        name: 'whatsapp',
        size: '',
        type: '',
      };

      switch (this.$session.get('brand')) {
        case '':
          icon.size = '30px';
          icon.type = 'l';
          break;
        case 'volkswagen':
          icon.size = '24px';
          break;
        case 'audi':
          icon.size = '24px';
          break;
        case 'seat':
          icon.size = '24px';
          icon.type = 'l';
          break;
        default:
          break;
      }

      return icon;
    },
  },
};
